/**
 *
 * @module sessionAccountInfo
 *
 */

import Check from 'check-types';
import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

/**
 *
 * @class SessionAccountInfo
 * @desc Represents the session account info provided by the service.
 *
 */
export default class SessionAccountInfo {

    /**
     *
     * @param {String} id
     *
     */
    constructor(id) {

        const errorMessage = {
            ctor: 'SessionAccountInfo(id)',
            get id() {
                return `${this.ctor} id should be a String with length`;
            }
        };

        Check.assert.nonEmptyString(id, errorMessage.id, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.id = id;

    }

}



// WEBPACK FOOTER //
// ./src/services/session/sessionAccountInfo.js